<template>
  <div>
    <modal-bottom :value="opened" title="Detalhes do pedido" size="large" @input="handleModalInput">
        <div>
          <div>
            <loading class="pedido-loading" v-if="load"/>
            <div v-else-if="pedido">
              <div class="mb-3 text-center pedido-hero">
                <h5 class="font-weight-bold mb-0">
                  #{{pedido.id_contador}} <span class="small">- {{pedido.nome_fantasia}}</span>
                </h5>
                <div class="tamanho-2">
                  {{ pedido.data_pedido }}
                  <span class="text-nowrap" v-if="!pedido.data_agendamento && pedido.previsao"> | Previsão <b>{{ pedido.previsao.slice(-5) }}</b></span>
                </div>
                <div class="tamanho-2" v-if="pedido.nolocal">Local: {{ pedido.nolocal }}</div>
              </div>
              <div class="text-center" v-if="pedido.data_agendamento">
                <div class="font-weight-bold">**PEDIDO AGENDADO**</div>
                <div class="small">{{pedido.data_agendamento}}</div>
              </div>
              <hr>
              <div v-if="pedido.cliente">
                <div class="text-center">
                  <b class="h5 font-weight-bold m-0">{{pedido.cliente.nome_cliente}}</b>
                  <div v-if="pedido.cliente.telefone">
                    {{pedido.cliente.telefone | phone}}
                  </div>
                </div>
                <div class="row no-gutters mt-3" v-if="pedido.cliente.telefone">
                  <div class="col-6 pr-1">
                    <a :href="`tel:${pedido.cliente.telefone}`" class="btn btn-ligar btn-block" title="Telefone"><i class="fa-solid fa-phone mr-1"></i> Ligar</a>
                  </div>
                  <div class="col-6 pl-1">
                    <a :href="`https://wa.me/55${pedido.cliente.telefone}`" target="_blank" class="btn btn-whatsapp btn-block" title="WhatsApp"><i class="fa-brands fa-whatsapp mr-1"></i> WhatsApp</a>
                  </div>
                </div>
                <hr>
                <div class="d-flex justify-content-between align-items-center address-box" v-if="pedido.cliente.logradouro && pedido.tipo_pedido === '1'">
                  <div class="mr-3">
                    {{pedido.cliente.logradouro}}, {{pedido.cliente.numero}} - {{pedido.cliente.bairro}}, {{pedido.cliente.complemento}}
                  </div>
                  <button class="btn btn-primary btn-mapa btn-auto" @click="$emit('openGps', pedido.cliente)">
                    <i class="fa-solid fa-map-location-dot"></i>
                    <small>Abrir Mapa</small>
                  </button>
                </div>
              </div>
              <hr>
              <div>
                <div class="small" v-if="!(pedido.produtos || []).length">
                  Os produtos deste pedido não estão mais disponíveis.
                </div>
                <div v-else>
                  <div v-for="i in (pedido.produtos || [])">
                    <span class="product-price float-right" v-if="!i.id_beneficio">{{(i.valor * i.quantidade) | valor}}</span>
                    <span class="badge badge-warning float-right" v-else><i class="fa-solid fa-trophy mr-1"></i> Benefício</span>
                    <div>
                      <div class="mb-0 tamanho-1"><b>{{i.quantidade}}x</b> {{i.produto.nome_produto}}</div>
                      <div v-for="d in i.divisoes" class="m-0 pl-2 tamanho-2"> # {{d.nome_produto}}</div>
                      <div v-for="d in i.adicionais" class="m-0 pl-2 tamanho-2">
                        <b v-show="d.qtd > 1">{{d.qtd}}x</b> + {{d.nome_produto}}
                        <span v-show="d.valor > 0">{{(d.qtd * d.valor) | valor}}</span>
                        <div v-if="d.adicionais">
                          <div class="ml-3" v-for="da in d.adicionais">
                            • <b v-if="da.qtd > 1">{{parseFloat(da.qtd)}}x</b> {{da.nome_produto}} <span v-if="da.valor > 0"> - {{da.qtd * da.valor | valor}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="m-0 pl-2 tamanho-2" v-show="i.observacao">
                        <b>Obs:</b> {{i.observacao}}
                      </div>
                    </div>
                  </div>
                  <hr>
                </div>
                <div v-if="pedido.origin !== '4'">
                  <div class="row" v-if="pedido.id_pagamento !== '5'">
                    <div class="col">Pagamento:</div>
                    <div class="col-5 align-self-center text-right">
                      {{pedido.nome_pagamento}}
                    </div>
                  </div>
                  <div class="row" v-show="pedido.troco > 0">
                    <div class="col">
                      Troco p/:
                    </div>
                    <div class="col-5 align-self-center text-right">
                      {{pedido.troco | valor}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      Subtotal:
                    </div>
                    <div class="col-4 align-self-center text-right">
                      {{(parseFloat(pedido.valor_total) + parseFloat(pedido.valor_desconto) - parseFloat(pedido.valor_frete)) - parseFloat(pedido.valor_taxa ? pedido.valor_taxa : 0) | valor}}
                    </div>
                  </div>
                  <div class="row" v-show="pedido.valor_desconto > 0">
                    <div class="col">
                      Desconto:
                    </div>
                    <div class="col-4 align-self-center text-right">
                      {{pedido.valor_desconto | valor}}
                    </div>
                  </div>
                  <div class="row" v-show="parseInt(pedido.tipo_pedido) === 1">
                    <div class="col">
                      Entrega:
                    </div>
                    <div class="col-4 align-self-center text-right">
                      {{pedido.valor_frete | valor}}
                    </div>
                  </div>
                  <div class="row" v-show="pedido.valor_taxa && pedido.valor_taxa !== '0'">
                    <div class="col">
                      {{pedido.valor_taxa > 0 ? 'Taxa' : 'Desconto'}} Pagamento
                    </div>
                    <div class="col-4 align-self-center text-right">
                      {{pedido.valor_taxa | valor}}
                    </div>
                  </div>
                  <div class="row total-row">
                    <div class="col-4">
                      {{ isPedidoPago(pedido) ? 'Valor Pago:' : 'Total:' }}
                    </div>
                    <div class="col-8 align-self-center text-right h6">
                      <b>{{pedido.valor_total | valor}}</b>
                    </div>
                  </div>
                  <div class="row" v-if="isPedidoPago(pedido)">
                    <div class="col text-center">
                      <span class="payment-status-tag">
                        <i class="fa-solid fa-circle-check payment-status-tag__icon"></i>
                        Pagamento já realizado
                      </span>
                    </div>
                  </div>
                </div>
                <div class="p-3 mt-4 mb-2 order-note" v-if="pedido.obs_pedido">
                  <div class="small font-weight-bold">Observação do pedido</div>
                  {{ pedido.obs_pedido }}
                </div>
              </div>
            </div>
            <c-offline v-else/>
          </div>
        </div>
    </modal-bottom>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import COffline from "@/components/COffline";
import ModalBottom from "@/components/ModalBottom";
export default {
  name: "InfoPedido",
  components: {ModalBottom, COffline, Loading},
  props: ['empresa'],
  data() {
    return {
      opened: false,
      pedidoRequestId: 0,
      token: localStorage.getItem('key'),
      load: false,
      pedido: null
    }
  },

  watch: {
    '$route.query.pedido': {
      immediate: true,
      handler(idPedido) {
        if (idPedido) {
          this.loadPedido(idPedido);
          return;
        }

        this.pedidoRequestId += 1;
        this.opened = false;
      }
    }
  },

  methods: {
    isPedidoPago(pedido) {
      return pedido?.pago === true || pedido?.pedido_pago === '1' || pedido?.categoria === '5' || pedido?.categoria_pagamento === '5';
    },

    openPedido(ped) {
      const idPedido = String(ped.id_pedido);

      if (String(this.$route.query.pedido || '') === idPedido) {
        this.loadPedido(idPedido);
        return;
      }

      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: { ...this.$route.query, pedido: idPedido }
      });
    },

    loadPedido(idPedido) {
      const requestId = ++this.pedidoRequestId;
      this.load = true;
      this.pedido = null;
      this.opened = true;

      this.$http.get(`delivery/pedidos/${this.token}/${idPedido}`)
        .then(response => {
          if (requestId !== this.pedidoRequestId) return;
          this.load = false;

          if (response.data && response.data.id_pedido) {
            this.pedido = response.data;

          } else {
            this.$swal("Pedido não encontrado!");
            this.closePedido();
          }

        }, response => {
          if (requestId !== this.pedidoRequestId) return;
          this.load = false;

          if (Number(response.status) === 404) {
            this.$swal('Pedido não encontrado!');
            this.closePedido();
          }
        });
    },

    handleModalInput(opened) {
      if (!opened) this.closePedido();
    },

    closePedido() {
      if (!this.$route.query.pedido) {
        this.opened = false;
        return;
      }

      const query = { ...this.$route.query };
      delete query.pedido;
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query
      });
    }
  }
}
</script>

<style scoped>
.pedido-loading {
  min-height: clamp(220px, 45dvh, 420px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-whatsapp,
.btn-whatsapp:hover,
.btn-whatsapp:focus,
.btn-whatsapp:active {
  border-color: #25d366;
  background-color: #25d366;
  color: #fff;
}

.btn.btn-ligar,
.btn.btn-ligar:hover,
.btn.btn-ligar:focus,
.btn.btn-ligar:active {
  border-color: #3498db !important;
  background-color: #3498db !important;
  color: #fff !important;
}

.btn.btn-ligar:hover,
.btn.btn-ligar:focus,
.btn.btn-ligar:active {
  border-color: #2583c5 !important;
  background-color: #2583c5 !important;
}

.btn.btn-mapa {
  width: auto;
  min-height: 40px;
  padding: 6px 12px;
  border-radius: 18px;
  font-size: 0.82rem;
}

.pedido-hero {
  padding: 22px 18px;
  border-radius: 24px;
  background: var(--bg-theme-secondary);
  border: 1px solid var(--border-color);
}

.address-box {
  padding: 14px 16px;
  border-radius: 22px;
  background-color: var(--secondary);
  border: 1px solid var(--border-color);
}

.order-note {
  border: 1px solid var(--border-color);
  border-radius: 22px;
  background-color: var(--secondary);
}

.product-price {
  font-size: 0.98rem;
  line-height: 1.4;
  color: var(--text-default);
}

.total-row {
  font-weight: 700;
}

.payment-status-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid rgba(40, 167, 69, 0.18);
  background: rgba(40, 167, 69, 0.12);
  color: #1f8f45;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1;
}

.payment-status-tag__icon {
  font-size: 0.9rem;
}

</style>
